import React from 'react';
import { ControlWrapper, SearchWrapper } from 'components/styled-components';
import { InputGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import FilterMenu from 'containers/Manage-Admin/api-users/filterMenu';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';

const Controls = ({
  statusOptions,
  status,
  handleChangeFilter,
  handleQueryChange,
}) => {
  const throttledSearch = debounce(
    handleQueryChange,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  const handleChange = e => throttledSearch(e.target.value);
  return (
    <SearchWrapper padding="1rem 2rem">
      <ControlWrapper>
        <InputGroup
          leftIcon={IconNames.SEARCH}
          placeholder={`Search API Users`}
          className="large-text-group light-blue"
          onChange={handleChange}
        />
        <div style={{ marginRight: '1rem' }} />
        <FilterMenu
          handleChangeFilter={handleChangeFilter}
          selectedFilter={status}
          statusFilters={statusOptions}
        />
      </ControlWrapper>
    </SearchWrapper>
  );
};

export default Controls;
